import React from 'react';
import { X, Plus, RotateCcw } from 'lucide-react';
import { WIDGET_REGISTRY, ALL_WIDGET_IDS } from './widgetRegistry';

const DashboardCustomizer = ({ open, onClose, widgets, onAddWidget, onReset }) => {
  if (!open) return null;
  const enabledIds = new Set(widgets.filter((w) => w.enabled).map((w) => w.id));
  const available = ALL_WIDGET_IDS.filter((id) => !enabledIds.has(id));

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-end bg-slate-900/30 backdrop-blur-sm"
      onClick={onClose}
      data-testid="dashboard-customizer-overlay"
    >
      <div
        className="bg-white w-full max-w-md h-full overflow-y-auto shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="dashboard-customizer-panel"
      >
        <div className="p-6 border-b border-slate-200 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-chivo font-bold text-slate-900">Customize Dashboard</h2>
            <p className="text-xs font-ibm text-slate-500 mt-1">Add widgets, drag to reorder, remove what you don&apos;t need.</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2 hover:bg-slate-100 rounded-sm"
            data-testid="close-customizer-btn"
          >
            <X size={18} />
          </button>
        </div>

        <div className="p-6">
          <h3 className="text-xs font-ibm font-semibold uppercase tracking-widest text-slate-600 mb-3">
            Available widgets
          </h3>
          {available.length === 0 ? (
            <p className="text-sm font-ibm text-slate-500" data-testid="no-available-widgets">
              All widgets are already on your dashboard.
            </p>
          ) : (
            <div className="space-y-2" data-testid="available-widgets-list">
              {available.map((id) => {
                const entry = WIDGET_REGISTRY[id];
                return (
                  <div
                    key={id}
                    className="flex items-start justify-between gap-3 border border-slate-200 rounded-sm p-3 hover:border-slate-400 transition-colors"
                    data-testid={`available-widget-${id}`}
                  >
                    <div className="flex-1">
                      <p className="font-ibm font-semibold text-slate-900 text-sm">{entry.title}</p>
                      <p className="text-xs font-ibm text-slate-500 mt-0.5">{entry.description}</p>
                    </div>
                    <button
                      type="button"
                      onClick={() => onAddWidget(id)}
                      className="flex items-center gap-1 px-3 py-1.5 bg-slate-900 text-white text-xs font-ibm font-semibold uppercase tracking-widest rounded-sm hover:bg-slate-700 transition-colors"
                      data-testid={`add-widget-${id}`}
                    >
                      <Plus size={12} />
                      Add
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="p-6 border-t border-slate-200">
          <button
            type="button"
            onClick={onReset}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 border border-slate-300 text-slate-700 text-xs font-ibm font-semibold uppercase tracking-widest rounded-sm hover:bg-slate-50 transition-colors"
            data-testid="reset-layout-btn"
          >
            <RotateCcw size={14} />
            Reset to default layout
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardCustomizer;
